import request from "@/utils/request";

// 登陆微信扫码
export function doLoginQrcode(data) {
  return request({
    url: "/v3/iw-framework/pc/wx/v1/doLoginQrcode",
    method: "GET",
    data: { data }
  });
}

// 绑定微信扫码(二维码url)
export function doBindQrcode(data) {
  return request({
    url: "/v3/iw-framework/pc/wx/v1/doBindQrcode",
    method: "POST",
    data: { data }
  });
}

// 获取绑定微信二维码
export function getBindQRCode(data) {
  return request({
    url: "/v3/iw-framework/pc/wx/v1/getBindQRCode",
    method: "POST",
    data: { data }
  });
}

// 获取登陆微信二维码
export function getLoginQRCode(data) {
  return request({
    url: "/v3/iw-framework/pc/wx/v1/getLoginQRCode",
    method: "POST",
    data: { data }
  });
}

// 获取二维码状态
export function getQRCodeStatus(data) {
  return request({
    url: "/v3/iw-framework/pc/wx/v1/getQRCodeStatus",
    method: "POST",
    data: { data }
  });
}
